const { pathname, host } = window.location
export const PROXY_PREFIX = '/proxy-boss'
export const isProxyMode = process.env.IS_OE_BUILD_SIM && host.includes('local') && pathname.startsWith(PROXY_PREFIX)
export const shouldAddProxyPrefix = (path: string) => isProxyMode ? path.startsWith(PROXY_PREFIX) ? path : PROXY_PREFIX + path : path